module.exports = __webpack_public_path__ + "img/homeIc3.82cfa30a.png";